@if (useSiteLogoTemplate) {
<cx-banner>
  @if (!disabledLinkLogo) {
  <cx-generic-link>
    <a role="link" [routerLink]="urlLink">
      <cx-media removeImageTitleAttr>
        <img src="../../../../../../public/icons/png/logo-shimano.png" alt="Shimano" />
      </cx-media>
    </a>
  </cx-generic-link>
  } @else {
  <cx-media>
    <img src="../../../../../../public/icons/png/logo-shimano.png" alt="Shimano" />
  </cx-media>
  }
</cx-banner>
}
